import { render, staticRenderFns } from "./AddConfiguration.vue?vue&type=template&id=e86bfcd2&scoped=true"
import script from "./AddConfiguration.vue?vue&type=script&lang=js"
export * from "./AddConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86bfcd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e86bfcd2')) {
      api.createRecord('e86bfcd2', component.options)
    } else {
      api.reload('e86bfcd2', component.options)
    }
    module.hot.accept("./AddConfiguration.vue?vue&type=template&id=e86bfcd2&scoped=true", function () {
      api.rerender('e86bfcd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/components/AddConfiguration.vue"
export default component.exports